export default {"src":"/_next/static/media/bestSeller.ede224e0.gif","height":36,"width":36,"blurWidth":0,"blurHeight":0};